import type { ReactNode } from 'react'
import { PostAttachmentsProvider } from 'modules/attachments/components/context'
import { CommentEditor } from '../comment-editor'
import type { MessageBoxProps } from './message-box.types'
import { useCommentBox } from './use-comment-box'

export const MessageBox = ({
  parentId,
  setActiveComment = () => {},
  setOpenedResponses = () => {},
  onError,
  level = 0,
  replyInfo,
}: MessageBoxProps): ReactNode => {
  const { handleAddComment, attachmentsRef, setAttachments, initialHtml, initialMentions } =
    useCommentBox({
      parentId,
      level,
      setActiveComment,
      setOpenedResponses,
      onError,
      replyInfo,
    })

  return (
    <PostAttachmentsProvider ref={attachmentsRef} isEditable onChange={setAttachments}>
      <CommentEditor
        handleAddComment={handleAddComment}
        setActiveComment={setActiveComment}
        isRoot={level === 0}
        initialHtml={initialHtml}
        initialMentions={initialMentions}
      />
    </PostAttachmentsProvider>
  )
}
